export default __webpack_public_path__ + "static/media/BitterPro-Medium.ca7963e6.ttf";